import { differenceBy, isEqual, omit } from 'lodash-es';
import type { UpdateMetricsPayload } from '../api/types';
import type { MetricEntry, MetricsFormState } from '../types';

export default function parseMetricsFormState(
  data: MetricsFormState,
  originalData: MetricEntry[]
): UpdateMetricsPayload[] {
  const payload = data.items.reduce<UpdateMetricsPayload[]>((acc, dataItem) => {
    const originalDataItem = originalData.find((metric) => metric.id === dataItem.id);

    // filter only metrics that has changed
    const hasChanged = !isEqual(dataItem, originalDataItem);

    if (hasChanged && originalDataItem) {
      // get only changed project from metrics that has been changed
      const changedProjects = differenceBy(dataItem.projects, originalDataItem.projects, 'value');

      acc.push({
        ...omit(dataItem, ['name']),
        projects: changedProjects.map((cp) => ({ value: cp.value, id: cp.id })),
      });
    }

    return acc;
  }, []);

  return payload;
}
